import { useAtomValue } from 'jotai'
import { Navigate } from '@tanstack/react-router'
import { useTar } from '@/modules'
import { userAtom } from '@/store/userAtoms'
import { InviteAFriendForm } from './InviteAFriendForm'
import { MyInvitationsTable } from './MyInvitationsTable'
import { InviteAFriendHeroArt } from './InviteAFriendHeroArt'

export const InviteAFriendPage = () => {
  const { t } = useTar()
  const user = useAtomValue(userAtom)

  if (!user) return <Navigate to="/" />

  return (
    <div className="container mx-auto p-6">
      <div className="max-w-3xl mx-auto space-y-8">
        <header className="relative overflow-hidden py-6">
          <InviteAFriendHeroArt />
          <div className="relative space-y-2">
            <h1 className="text-3xl font-bold text-foreground">{t('refer.title')}</h1>
            <p className="text-muted-foreground">{t('refer.description')}</p>
          </div>
        </header>
        <InviteAFriendForm />
        <MyInvitationsTable />
      </div>
    </div>
  )
}
